<template>
  <div class="header">
    <div class="header-main">
      <div class="logo">
        <img src="../../assets/images/logo-blue.png" alt="logo" @click="openView" />
      </div>
      <!-- <div class="changeLan" @click="handleChangeLanguage">{{ language }}</div> -->
    </div>
  </div>
</template>
<script>
import VueCookie from "vue-cookie";
export default {
  data(){
    return {
      language: "English"
    }
  },
  watch: {
    language(nv) {
      this.$emit('changeLanguage', nv)
    }
  },
  mounted () {
    var _hmt = _hmt || [];
    (function () {
      var hm = document.createElement("script");
      hm.src = "https://hm.baidu.com/hm.js?102d1faf861f9cfd8341a3f27f694404";
      var s = document.getElementsByTagName("script")[0];
      s.parentNode.insertBefore(hm, s);
    })();
    if (VueCookie.get('language')) {
      this.$i18n.locale = VueCookie.get('language');
      if (this.$i18n.locale === 'en') {
        this.language = 'English'
      } else {
        this.language = '简体中文'
      }
    }
  },
  methods: {
    handleChangeLanguage () {
      if (this.$i18n.locale === 'en') {
        this.$i18n.locale = 'cn'
        this.language = '简体中文'
      } else {
        this.$i18n.locale = 'en'
        this.language = 'English'
      }
      VueCookie.set('language', this.$i18n.locale, { expires: '1M' })
    },
    openView () {
      let routeData = this.$router.resolve({
        path: "/"
      });
      window.open(routeData.href, "_blank");
    }
  }
};
</script>
<style lang="less" scoped>
.click_active {
  &:active {
    opacity: 0.5;
  }
}
.input-body {
  outline: none;
  border: none;
  background: #f7f8fa;
}
.operation {
  height: 80px;
  line-height: 78px;
  font-size: 18px;
  text-align: center;
  &:hover {
    cursor: pointer;
  }
  .click_active;
}
.header {
  width: 100%;
  min-width: 1000px;
  // height: 136px;
  border-bottom: 2px solid rgba(2, 116, 179, 1);
  font-family: 'Circular Std Book';
  background: #ffffff;
  .header-main {
    width: 90%;
    display: flex;
    justify-content: space-between;
    height: 70px;
    margin: 0 auto;
    // overflow-x: hidden;
    .logo {
      .click_active;
      width: 18%;
      margin-top: 16px;
      img {
        width: 151px;
        height: 40px;
      }
      &:hover {
        cursor: pointer;
      }
    }
    .search-box {
      position: relative;
      min-width: 580px;
      width: 50%;
      height: 48px;
      .header-fuzzy-search {
        z-index: 998;
        position: absolute;
        top: 65px;
        left: 0;
        width: 100%;
        border: 1px solid rgba(2, 116, 179, 1);
        border-top: none;
        border-bottom: none;
        background: #ffffff;
        ul > li {
          width: 100%;
          height: 45px;
          line-height: 45px;
          font-size: 16px;
          color: #777777;
          text-indent: 10px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          border-bottom: 1px solid rgba(0, 0, 0, 0.1);
          &:hover {
            cursor: pointer;
            color: #ffffff;
            background: rgba(7, 162, 245, 0.8);
          }
        }
      }
      .search-input {
        position: absolute;
        top: 16px;
        left: 0;
        width: 93%;
        min-width: 500px;
        height: 48px;
        color: #0274b3;
        font-size: 21px;
        text-indent: 20px;
        font-family: 'Circular Std Book';
      }
      .clear-btn {
        position: absolute;
        top: 23px;
        right: 72px;
        width: 40px;
        height: 40px;
        background: url('./images/clear.png') no-repeat center center;
        background-size: 100%;
        &:hover {
          cursor: pointer;
        }
        .click_active;
      }
      .search-btn {
        position: absolute;
        top: 16px;
        right: 0;
        width: 72px;
        height: 48px;
        background: url('./images/btn.png') no-repeat center center;
        background-size: 100%;
        &:hover {
          cursor: pointer;
        }
        .click_active;
      }
    }
    .changeLan {
      .operation;
      min-width: 70px;
    }
    .operate {
      width: 28%;
      height: 100%;
      display: flex;
      justify-content: space-around;
      .language {
        .operation;
        min-width: 100px;
        img {
          vertical-align: middle;
          margin: 0 3px;
        }
      }
      .sign {
        .operation;
        min-width: 80px;
      }
      .user {
        .operation;
        min-width: 75px;
        img {
          margin-top: -3px;
          width: 25px;
          height: 25px;
          vertical-align: middle;
        }
      }
    }
  }
  .breadcrumb-template {
    height: 56px;
  }
}
</style>




// WEBPACK FOOTER //
// src/pages/aceranking/header.vue